
const digest = '504dde6bdbfa8a1591bbbac01df674301b1ef61b39c97716a1d1ee2a12b41b7e';
const css = `._lightboxjs_1jf5j_1 {
  margin: 0;
  padding: 0;
}

._lightboxjs_1jf5j_1 * {
  box-sizing: border-box;
}

/* .lightboxjs img,
.lightboxjs svg,
.lightboxjs video {
  display: block;
  vertical-align: middle;
  height: auto;
  max-width: 100%;
} */

._slideshowBtn_1jf5j_37 {
  padding-bottom: 2px;
}

._closeIcon_1jf5j_45:hover,
._closeIcon_1jf5j_45:focus,
._iconsHeader_1jf5j_49 svg:hover,
._iconsHeader_1jf5j_49 svg:focus,
._prev1_1jf5j_53 span:hover,
._next1_1jf5j_55:hover,
._icon_1jf5j_49:hover {
  text-decoration: none;
  cursor: pointer;
  /* color: rgb(230, 230, 230); */
}

._prevIcon_1jf5j_69:hover,
._nextIcon_1jf5j_71:hover {
  background-color: rgba(0, 0, 0, 0.8);
  color: rgb(230, 230, 230);
}

._show_1jf5j_81 {
  display: flex;
}

._displayHidden_1jf5j_89 {
  display: none;
}

._thumbnail_1jf5j_97 {
  opacity: 1;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

._next1_1jf5j_55 {
  right: 1%;
  padding-left: 2vw;
  padding-right: 3vw;
}

._prev1_1jf5j_53 {
  left: 2%;
  padding-right: 2vw;
}

._thumbnails_1jf5j_133 {
  transition: border 0.3s;
}

._thumbnail_1jf5j_97 {
  display: inline;
}

._thumbnailsWithCaption_1jf5j_149 {
  width: 90%;
}

._thumbnailsOuterContainer_1jf5j_157 {
  position: absolute;
  bottom: 4%;
  height: 5vh;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}

._navigationDots_1jf5j_181 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

/* Mobile screens */
@media screen and (min-width: 20em) {
  ._imageSlide_1jf5j_197 {
    height: 67vw;
    width: 60%;
  }

  ._thumbnailsOuterContainer_1jf5j_157 {
    position: absolute;
    bottom: 7%;
    width: 100vw;
    /* width: 100%; */
  }

  ._thumbnailsAndCaption_1jf5j_221 {
    height: 23vh;
    bottom: 2%;

  }

  ._hideControlsBar_1jf5j_233 ._slideshowImg_1jf5j_233 {
    /* height: 100vh; */
  }

  ._rotateImgInnerContainer_1jf5j_241 {
    top: 8%;
  }

  ._hideControlsBar_1jf5j_233 ._slideshowInnerContainer_1jf5j_249 {
    top: 0;
  }

  ._thumbnail_1jf5j_97 {
    width: 80px;
    max-width: 80px;
    height: 7vh;
  }

  ._videoThumbnailsOuterContainer_1jf5j_269 {
    bottom: 2%;
  }

  ._imgTitleContainer_1jf5j_277 {
    padding-bottom: 16px;
    width: 100vw;
    margin-top: 0;
    margin-bottom: 0;
  }

  ._thumbnails_1jf5j_133 {
    margin-left: auto;
    margin-right: auto;
  }

  ._next1_1jf5j_55 {
    right: 0.9%;
  }

  ._prev1_1jf5j_53 {
    left: 1.5%;
  }
}

._thumbnail_1jf5j_97 {
  height: 5vh;
  border-radius: 6px;
  margin-right: 7px;
  object-fit: cover;
}



._thumbnailsOuterContainerMetadata_1jf5j_337 {
  width: 78vw;
}

._videoThumbnailsOuterContainer_1jf5j_269 {
  bottom: 5%;
}

._thumbnailsAndCaption_1jf5j_221 {
  height: 19vh;
}

._htmlVideoOuterContainer_1jf5j_361 video {
  height: 100%;
  max-height: 70vh;
  width: 100%;
}

._caption_1jf5j_373 {
  position: absolute;
  bottom: 14%;
  width: 100vw;
  z-index: 10000000;
  margin-top: 10px;
  margin-left: auto;
  margin-right: auto;
}

._galleryImg_1jf5j_393 {
  cursor: pointer;
  margin: 0.2em;
}

._modalContainer_1jf5j_403 {
  width: 100vw;
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
}

._slideshowAnimContainer_1jf5j_441 {
  /* height: 100%;
  max-height: 100%; */
  direction: ltr;
  overflow: hidden;
  touch-action: none;
  padding: 0;
  overflow-y: hidden;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 1000000;
}

._fullScreenContainer_1jf5j_477 img {
  height: 100vh;
  max-width: 100%;
  /* max-height: 100vh; */
}

._imageInnerContainer_1jf5j_489 img {
  height: 80vh;
  max-width: 100%;
  max-height: 100%;
}

._imageInnerContainer_1jf5j_489 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._magnifyWrapper_1jf5j_527 {
  margin-bottom: 3em;
  margin-left: auto;
  margin-right: auto;
}

._slideshowInnerContainer_1jf5j_249 {
  position: fixed; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: top 0.2s ease-in-out 0s;
  top: 12%;
  align-content: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  z-index: 1000000;
}

._slideshowInnerVideoContainer_1jf5j_567 {
  top: 6%;
}

._slideshowInnerContainerThumbnails_1jf5j_575 {
  top: 12%;
}

._hideControlsBar_1jf5j_233  {
  top: 0;
}

._fullScreenContainer_1jf5j_477 {
  top: 0;
}

._lightboxContainer_1jf5j_599 {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

._next1_1jf5j_55,
._prev1_1jf5j_53 {
  top: calc(50% - 20px);
  position: absolute;
  display: flex;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  padding-bottom: 2vh;
  padding-top: 2vh;
  user-select: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 30px;
  width: 40px;
  height: 40px;
  font-size: 18px;
  z-index: 10000000;
}



._next1_1jf5j_55:hover,
._prev1_1jf5j_53:hover {
  color: rgb(230, 230, 230);
}

._slideshowAnimImg_1jf5j_671 {
  position: absolute;
  max-width: 100vw;
}

._controls_1jf5j_681 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

._iconsHeader_1jf5j_49 {
  color: white;
  display: flex;
  flex-direction: row;
  /* align-items: center;
    justify-content: center; */
  cursor: pointer;
  z-index: 999999999;
  /* padding: 0.14vw; */
}

._iconHeaderDefault_1jf5j_715 {
  position: absolute;
  top: 10px;
  right: 45px;
}

._ytVideo_1jf5j_727 {
  aspect-ratio: 16 / 9;
  height: 65vh;
  width: 100%;
}

._videoOuterContainer_1jf5j_739 {
  width: 65%;
  margin-left: auto;
  margin-right: auto;
  height: 60vh;
  max-height: 65vh;
}

._htmlVideoOuterContainer_1jf5j_361 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._customVideoContainer_1jf5j_767, ._customEmbedContainer_1jf5j_767 {
  margin-left: auto;
  margin-right: auto;
}

._videoIconsHeader_1jf5j_777 {
  position: fixed;
  top: 4%;
  right: 3%;
}

._lightbox_1jf5j_1 ._iconsHeader_1jf5j_49 svg {
  transition: 0.3s all;
}

._iconsHeader_1jf5j_49 svg:active {
  transform: scale(0.97);
}

._imgTitle_1jf5j_277 {
  text-align: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

._iconsHeader_1jf5j_49 svg {
  margin-left: 0.6em;
  padding: 0.2em;
  transition: all 0.1s;
  /* width: 32px;  */
  /* font-size: 18px; */
  line-height: 16px;
  vertical-align: baseline;
}

._icon_1jf5j_49 {
  /* width: 32px;  */
}

@media screen and (min-width: 6em) {
  ._iconsHeader_1jf5j_49 {
    top: 3%;
  }

  ._slideshowAnimContainer_1jf5j_441 {
    width: 100vw;
  }

  ._iconsHeader_1jf5j_49 svg {
    /* width: 34px;  */
    padding-right: 0.3em;
  }

  ._lightboxjs_1jf5j_1 img {
    cursor: pointer;
  }

  ._thumbnail_1jf5j_97 {
    height: 9vh;
    /* width: 22vw; */
  }

  ._next1_1jf5j_55 {
    top: calc(48% - 20px);
  }

  ._prev1_1jf5j_53 {
    top: calc(48% - 20px);

  }

  ._iconHeaderCenter_1jf5j_911 {
    width: 100vw; 
    display: flex;
    flex-direction: row;
    cursor: pointer;
    position: fixed;
    top: 10px;
    justify-content: center;
    left: 0;
  }

}

@media screen and (min-width: 39em) {
  ._slideshowAnimContainer_1jf5j_441 {
    width: 100vw;
  }

  ._slideshowInnerContainer_1jf5j_249 {
    /* width: 100vw;
    height: 95vh;
    position: absolute; */
  }

  ._imgTitleContainer_1jf5j_277 {
    padding-bottom: 0px;
  }
  

  ._next1_1jf5j_55 {
    right: 0.7%;
  }

  ._iconHeaderCenter_1jf5j_911 {
    width: 100%; 
    display: flex;
    flex-direction: row;
    cursor: pointer;
    position: fixed;
    top: 10px;
    justify-content: center;
    left: 0;

  
  }

  /* .thumbnailsOuterContainer {
    bottom: 10%;
  } */

  /* .hideControlsBar .slideshow_img {
    height: 70vh;

  }

  .hideControlsBar {
    top: 10%;
  } */

  ._fullScreenContainer_1jf5j_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._fullScreenContainer_1jf5j_477 img {
    height: 100vh;
  }

  ._thumbnails_1jf5j_133 {
    margin-top: 0.6em;
  }

  ._thumbnail_1jf5j_97 {
    /* height: 8vh; */
    width: 80px;
    max-width: 80px;
  }

  ._iconsHeader_1jf5j_49 svg {
    /* width: 32px; 
      font-size: 32px; */
  }

  ._prev1_1jf5j_53 {
    left: 2.7%;
    padding-right: 2vw;
  }
}

/* Desktop screens */
@media screen and (min-width: 42em) {
  ._imageSlide_1jf5j_197 {
    height: 70vh;
    width: 80vw;
  }

  ._innerContainerWithTopCaption_1jf5j_1103 {
    top: 8%;
  }

  ._slideshowImgFullscreen_1jf5j_1111 {
    display: grid;
    width: 92vw;
    place-items: start;
    margin-left: auto;
    margin-right: auto;
    scrollbar-gutter: stable both-edges;
  }

  ._thumbnailsAndCaption_1jf5j_221 {
    bottom: 0%;
  }
  
  ._rotateImgInnerContainer_1jf5j_241 {
    top: 2%;
  }

  ._slideshowInnerContainer_1jf5j_249 img {
    margin-top: 0vh;
    /* width: 70vw; */
  }

  ._fullScreenContainer_1jf5j_477 img {
    width: 80vw;
  }

  ._slideshowInnerContainerFullScreen_1jf5j_1163 {
    top: 0%;
  }

  ._fullScreenLightboxImg_1jf5j_1171 {
    margin-left: auto;
    margin-right: auto;
    height: 100vh;
  }

  ._slideshowInnerContainerImgMetadata_1jf5j_1183 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  ._slideshowInnerContainerFullScreen_1jf5j_1163 {
    height: 100vh;
    width: 100vw;
    position: absolute;
  }

  ._slideshowInnerContainerFullScreen_1jf5j_1163 img {
    object-fit: contain;
  }

  ._thumbnails_1jf5j_133 {
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin-top: 1.1em;
  }

  ._thumbnails_1jf5j_133::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  ._opacity-fade_1jf5j_1237 {
    transition: opacity 0.3s;
    -webkit-transition: opacity 0.3s;
    opacity: 1;
  }

  ._thumbnailsOuterContainer_1jf5j_157 {
    margin-top: 0.1em;
    padding-top: 0.3em;
    height: 5vh;
    bottom: 11%;
  }

  ._thumbnailsAndCaption_1jf5j_221 {
    bottom: 0%;
  }

  ._thumbnail_1jf5j_97,
  ._imageSliderThumbnails_1jf5j_1273 img {
    height: 10vh;
    /* width: 7em; */
  }

  ._slideshowAnimContainer_1jf5j_441 {
    width: 100vw;
  }

  /* .slideshowInnerContainer {
    width: 100vw;
    height: 95vh;
  } */

  ._hideControlsBar_1jf5j_233 {
    /* height: 100vh; */
  }

  ._fullScreenContainer_1jf5j_477 {
    width: 100vw;
    /* height: 100vh; */
  }

  ._iconsHeader_1jf5j_49 svg {
    /* width: 37px;
      font-size: 34px; */
  }

  ._prev1_1jf5j_53 {
    left: 2%;
    padding-right: 2vw;
  }

  ._next1_1jf5j_55 {
    right: 0.4%;
  }

  
  ._slideshowImgMetadata_1jf5j_1349 {
    width: 78vw;
  }

  ._prev1Metadata_1jf5j_1357 {
    left: 1%;
  }

  ._navigationDots_1jf5j_181 {
    gap: 8px;
  }

 
}

@media screen and (min-width: 53em) {
  
  ._slideshowImg_1jf5j_233 {
    display: grid;
    width: 100vw;
    height: 70vh;
    place-items: start;
    /* margin-top: 7vh; */
  }

  ._slideshowImgWithCaption_1jf5j_1399 {
    height: 68vh;
  }

  ._hideControlsBar_1jf5j_233 ._slideshowImg_1jf5j_233, ._hideControlsBarAndCaption_1jf5j_1407 ._slideshowImg_1jf5j_233  {
    padding-top: 12vh;
  }

  ._fullScreenContainer_1jf5j_477 ._slideshowImg_1jf5j_233 {
    padding-top: 0vh;
  }


  ._lightboxImg_1jf5j_1425 {
      /* height: 70vh; */
  }

  ._thumbnail_1jf5j_97 {
    width: 95px;
    max-width: 80px;
  } 

  ._slideshowImgMetadata_1jf5j_1349 {
    width: 78vw;
  }
}
  

@media screen and (min-width: 80em) {
  ._slideshowInnerContainer_1jf5j_249 img {
    /* width: 60vw; */
  }

  ._fullScreenContainer_1jf5j_477 img {
    width: 80vw;
  }
}

._lightIcon_1jf5j_1475,
._lightIcon_1jf5j_1475 svg {
  background-color: white;
  color: black;
}

._lightIcon_1jf5j_1475:hover,
._lightIcon_1jf5j_1475 svg:hover {
  background-color: white;
  color: black;
  fill: black;
}

._darkIcon_1jf5j_1501,
._darkIcon_1jf5j_1501 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: silver;
  fill: silver;
}

._darkIcon_1jf5j_1501:hover,
._darkIcon_1jf5j_1501 svg:hover {
  color: rgba(107, 107, 107, 0.8);
  fill: rgba(107, 107, 107, 0.8);
}

/* Header icons  */
._lightHeaderIcon_1jf5j_1531 svg {
  background-color: white;
  color: black;
  fill: black;
}

._lightHeaderIcon_1jf5j_1531 svg:hover {
  background-color: white;
  color: rgb(24, 24, 24, 0.8);
  fill: rgb(24, 24, 24, 0.8);

}

._darkHeaderIcon_1jf5j_1557 svg {
  background-color: transparent;
  /* background-color: #151515; */
  color: #626b77;
  fill: #626b77;
}

._darkHeaderIcon_1jf5j_1557 svg:hover {
  color: rgba(99, 99, 99, 0.8);
  fill: rgba(99, 99, 99, 0.8);
}

._magnifierImage_1jf5j_1581 {
  object-fit: contain;
}

._thumbnails_1jf5j_133 ._active_1jf5j_1589 {
  border: solid rgb(107, 133, 206) 2px;
}

._inactiveThumbnailBorder_1jf5j_1597 {
  border: solid transparent 2px;
}

._thumbnails_1jf5j_133 {
  width: 95%;
}

._emblaThumbs_1jf5j_1613 {
  --thumbs-slide-spacing: 2px; 
  /* --thumbs-slide-height: 9rem; */
  margin-top: var(--thumbs-slide-spacing);
}

@media screen and (max-width: 40em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  ._imgTitleContainer_1jf5j_277 {
    /* position: absolute;
    top: 12%; */
  }

  ._slideshowImg_1jf5j_233 {
    height: 100vh;
  }
}

@media screen and (max-width: 53em) {
  ._fullScreenSlideshowImg_1jf5j_1659 {
    margin-top: auto;
    margin-bottom: auto;
  }
}

@media screen and (max-width: 44em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */
  ._thumbnailsOuterContainer_1jf5j_157 {
    bottom: 11%;
  }

  ._thumbnailsAndCaption_1jf5j_221 {
    bottom: 4%;
  }
  
  ._imgTitleContainer_1jf5j_277 {
    /* position: absolute;
    top: 5%; */
  }
}

@media screen and (max-width: 46em) and (min-width: 30em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */

  /* .imgTitleContainer {
    position: absolute;
    top: 7%;
  } */
}

@media screen and (max-width: 49em) and (min-width: 45em) {
  /* .innerContainerWithTopCaption {
    position: relative;
  } */


  /* .imgTitleContainer {
    position: absolute;
    top: 5%;
  } */
}

@media screen and (max-width: 29em) {
  ._fullScreenContainer_1jf5j_477 img {
    object-fit: cover;
  }

  ._emblaThumbs_1jf5j_1613 {
    --thumbs-slide-spacing: 3px; 
    /* --thumbs-slide-height: 9rem; */
    margin-top: var(--thumbs-slide-spacing);
  }



  ._htmlVideo_1jf5j_361 {
    margin-top: 5vh;
  }

  ._thumbnails_1jf5j_133 {
    width: 98%;
  }

  ._thumbnail_1jf5j_97 {
    width: 80px;
    max-width: 80px;
  }

  ._htmlVideoOuterContainer_1jf5j_361 video {
    max-height: 65vh;
  }

  ._videoIconsHeader_1jf5j_777 {
    position: fixed;
    top: 2%;
    right: 15px;
  }

  ._videoOuterContainer_1jf5j_739 {
    width: 88%;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    max-height: 65vh;
  }

  ._htmlVideoOuterContainer_1jf5j_361 {
    width: 94%;
    margin-left: auto;
    margin-right: auto;
  }

  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 115px;
  }

  ._slideshowInnerVideoContainer_1jf5j_567 {
    top: 3%;
  }

  ._next1_1jf5j_55,
  ._prev1_1jf5j_53 {
    padding-bottom: 2vh;
    padding-top: 2vh;
  }

  ._next1_1jf5j_55 {
    padding-left: 4vw;
  }

  ._prev1_1jf5j_53 {
    padding-right: 4vw;
  }

  ._iconsHeader_1jf5j_49 {
    /* font-size: 28px; */
  }

}

@media screen and (max-width: 53em) {
  ._slideshowImg_1jf5j_233 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100vw;
    height: 70vh;
  }

  ._slideshowImg_1jf5j_233 img {
    margin-left: auto;
    margin-right: auto;
  }

  ._slideshowInnerContainerFullScreen_1jf5j_1163 {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    transition: top 0.2s ease-in-out 0s;
    top: 10%;
    align-content: center;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    z-index: 1000000;
  }

  ._containImg_1jf5j_1969 {
    object-fit: contain;
  }
}

._fullScreenContainer_1jf5j_477 img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

._thumbnails_1jf5j_133 {
  text-align: center;
  white-space: nowrap;
}

._reactTransformComponent_1jf5j_2001 {
  margin-left: auto;
  margin-right: auto;
}

._magnifierImage_1jf5j_1581 {
  margin-left: auto;
  margin-right: auto;
}

/* CSS loader  */
._loader_1jf5j_2023 {
  width: 44px;
  height: 44px;
  box-sizing: border-box;

  border-radius: 50%;

  display: inline-block;
  position: fixed;
  top: 35%;
  left: 50%;
  animation: _rotation_1jf5j_1 1s linear infinite;
}

@keyframes _rotation_1jf5j_1 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

._dayLoader_1jf5j_2069 {
  border: 5px solid #626b77;
  border-bottom-color: transparent;
}

._nightLoader_1jf5j_2079 {
  border: 5px solid #fff;
  border-bottom-color: transparent;
}

._lightboxImg_1jf5j_1425 {
  max-height: 70vh;
  margin-left: auto;
  margin-right: auto;
}

._controls_1jf5j_681 button, ._closeButton_1jf5j_2101, ._closeButtonRounded_1jf5j_2101 {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 16px;
}

._controls_1jf5j_681 svg {
  box-sizing: border-box;
}

._closeButton_1jf5j_2101 svg, ._closeButtonRounded_1jf5j_2101 svg {
  box-sizing: border-box;
  font-size: 16px;
  padding-top: 0.5px;
}

._closeButton_1jf5j_2101 {
  padding-top: 3px;
}

._closeButtonRounded_1jf5j_2101 {
  cursor: pointer;

}

._closeButtonRounded_1jf5j_2101 svg {
  margin: 0;
  padding: 5px;
  background-color: black;
  border-color: transparent;
  border-radius: 28px;

}

._thumbnailsAndCaption_1jf5j_221 {
  height: 19vh;
  margin-top: 0em;
  width: 100vw;
}

._thumbnailsWithCaption_1jf5j_149 {
  margin-top: 0em;
}

._slideImageAndCaption_1jf5j_2193 {
  top: 9%;
}

._slideImageAndCaption_1jf5j_2193._hideControlsBar_1jf5j_233 {
  top: 0;
}

._slideshowAnimContainer_1jf5j_441 {
  -ms-overflow-style: none;
  /* scrollbar-width: none;   */
}
._thumbnails_1jf5j_133::-webkit-scrollbar {
  display: none;
}

._roundedBorder_1jf5j_2225 {
  border-radius: 20px;
}

._maxWidthFull_1jf5j_2233 {
  max-width: 100%;
}

._maxWidthWithoutMagnifier_1jf5j_2241 {
  max-width: 80%;
}

@media screen and (max-width: 880px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    right: 5%;
  }
}

@media screen and (max-width: 480px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 180px;
  }
  
}

@media screen and (max-width: 440px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 160px;
  }
}

@media screen and (max-width: 410px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 140px;
  }
}

@media screen and (max-width: 385px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 135px;
    /* top: 24px; */
  }
}

@media screen and (max-width: 365px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 90px;
  }
}

@media screen and (max-width: 345px) {
  ._iconHeaderDefault_1jf5j_715 {
    position: fixed;
    left: 94px;
  }
}

@media screen and (max-width: 325px) {
  ._iconsHeader_1jf5j_49 {
    position: fixed;
    left: 60px;
  }
}

@media screen and (max-width: 300px) {
  ._iconsHeader_1jf5j_49 {
    position: fixed;
    left: 30px;
  }
}

._lightboxVideo_1jf5j_2379 {
  margin-left: auto;
  margin-right: auto;
}

._navigation-wrapper_1jf5j_2389 {
  position: relative;
}

._dots_1jf5j_2397 {
  display: flex;
  padding: 10px 0;
  justify-content: center;
}

._dot_1jf5j_2397 {
  border: none;
  width: 10px;
  height: 10px;
  background: #c5c5c5;
  border-radius: 50%;
  margin: 0 5px;
  padding: 5px;
  cursor: pointer;
}

._dot_1jf5j_2397:focus {
  outline: none;
}

._dot_1jf5j_2397._active_1jf5j_1589 {
  background: #000;
}

._arrow_1jf5j_2447 {
  position: absolute;
  top: 50%;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.2s;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  color: #fff;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
  font-family: sans-serif;
}

._leftArrow_1jf5j_2477 {
  left: 8px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._rightArrow_1jf5j_2491 {
  left: auto;
  right: 8px;
  padding-left: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
}

._arrow_1jf5j_2447:hover {
  color: rgb(230, 230, 230);
}

._arrow--disabled_1jf5j_2515,
._arrow--disabled_1jf5j_2515:hover {
  color: rgba(255, 255, 255, 0.5);
}

._navDotsMargin_1jf5j_2525 {
  margin-top: 12px;
}

._inactiveThumbnailBorderImgSlider_1jf5j_2533 {
  border: 'solid transparent 2px';
}

._ytVideoImgSlider_1jf5j_2541 {
  width: 100%;
  height: 100%;
}

._ytVideoImgSlider_1jf5j_2541 iframe {
  width: 100%;
  height: 100%;
}

._outerYTVideoImgSlider_1jf5j_2561 {
  height: 100%;
}

._lightboxjs_1jf5j_1 iframe {
  margin: none;
  padding: none;
  border: none;
}

._imgSliderArrow_1jf5j_2581 {
  z-index: 100000;
  background-color: transparent;
  border: none;
}

._thumbnails_1jf5j_133 {
  margin-left: auto;
  margin-right: auto;
}

._cursorPointer_1jf5j_2603 {
  cursor: pointer;
}

._lightboxjsIcon_1jf5j_2611 > * { color: inherit; fill: inherit }

._embla_1jf5j_1613 {
  margin-left: auto;
  margin-right: auto;
  --slide-spacing: 1rem;
  --slide-size: 100%;
  --slide-height: 19rem;
}

._emblaViewport_1jf5j_2631 {
  overflow: hidden;
  width: 100vw;
}

._emblaContainer_1jf5j_2641 {
  backface-visibility: hidden; 
  touch-action: pan-y;
  height: auto;
  margin-left: calc(var(--slide-spacing) * -1);
  display: grid;  
  grid-auto-flow: column;  
  grid-auto-columns: 100%; 
  max-width: 100vw;
  margin-left: auto;
  margin-right: auto; 
  /* width: 80%;
*/
}

._emblaContainerImgMetadata_1jf5j_2671 {
  width: 78vw;
  max-width: 78vw;
  height: 80vh;
}

._imgdrag_1jf5j_2683 ._emblaSlide_1jf5j_2683 {
  flex: 0 0 80%;
  min-width: 0;
  max-width: 100%;
  padding-left: 12px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

._emblaThumbsViewport_1jf5j_2703 {
  overflow: hidden;
}

._emblaThumbsContainer_1jf5j_2711 {
  display: flex;
  flex-direction: row;
  margin-left: calc(var(--thumbs-slide-spacing) * -1);
  width: 100%;
  /* align-items: center;
  text-align: center;
  width: fit-content; */
  /* justify-content: center; */
  
}

._emblaThumbsContainer_1jf5j_2711::before, ._emblaThumbsContainer_1jf5j_2711::after {
  content: '';  /* Insert pseudo-element */
  margin: auto; /* Make it push flex items to the center */
}


._emblaThumbsSlide_1jf5j_2747 {
  /* min-width: 0; */
  padding-left: var(--thumbs-slide-spacing);
  /* position: relative; */
  /* width: 140px; */
}

._emblaThumbsSlideImg_1jf5j_2761 {
  /* display: block; */
  height: var(--thumbs-slide-height);
  width: 100%;
  object-fit: cover;
}

._mlAuto_1jf5j_2775 {
  margin-left: auto;
}

._metadata_1jf5j_2783 {
  color: white;
}

._emblaSlideGrid_1jf5j_2791 {
  display: flex;
}

._metadata_1jf5j_2783 {
  text-align: left;
  min-width: 17vw;
  max-width: 17vw;
  padding-top: 5vw;
}

._metadataPanel_1jf5j_2813 {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

._metadataInnerContainer_1jf5j_2825 {
  padding-left: 7vw;
}

._metadataInnerContainer_1jf5j_2825 span {
  display: block;
}


._imgMetadataCloseBtn_1jf5j_2843 {
  position: absolute;
  top: 1%;
  right: 2%;
  background: none;
  color: white;
  border: none;
  cursor: pointer;
}

/* Styling from react-zoom-pan-pinch library */
._reactTransformWrapper_1jf5j_2865 {
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  overflow: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -khtml-user-select: none; /* Konqueror HTML */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  margin: 0;
  padding: 0;
}

._reactTransformComponent_1jf5j_2001 {
  display: flex;
  flex-wrap: wrap;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  padding: 0;
  transform-origin: 0% 0%;
}

._reactTransformComponent_1jf5j_2001 img {
  pointer-events: none;
}

._navigationDot_1jf5j_181 {
  height: 10px;
  width: 10px;
  background-color: silver;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}

._navigationDotContainer_1jf5j_2949 {
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 12px;
  padding-right: 12px;
}

._imgfade_1jf5j_2963._emblaContainer_1jf5j_2641 {
  transform: none !important; /* override Embla */
  display: flex;
  /* height: 250px; */
}

._notFullScreen_1jf5j_2975 {
  top: 0;
}

._imgfade_1jf5j_2963._emblaSlide_1jf5j_2683 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  position: absolute;
  /* top: 0; */
  left: 0 !important; /* override Embla */
  right: 0 !important; /* override Embla */
  opacity: 0;
  transition: opacity 0.5s;
  counter-increment: embla;
  border-radius: 0.5rem;
}

._imgFadeWithTopCaption_1jf5j_3011 {
  top: 16%;
  position: fixed;
}

._imgfade_1jf5j_2963._emblaSlideSelected_1jf5j_3021 {
  opacity: 1;
  transition: opacity 0.3s;
  z-index: 1;
}

._imgfade_1jf5j_2963._emblaSlide_1jf5j_2683:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

._fullImg_1jf5j_3047 {
  height: 84vh;
  max-height: 84vh;
  object-fit: contain;
}

._rotateImg90Deg_1jf5j_3059{
transform: rotate(90deg);
transition: transform 1s linear;
}  

._rotate_img_1jf5j_3069 {
transition: transform 0.7s linear;
}

._fullScreenContainer_1jf5j_477 img {
/* max-height: 100vh; */
}

._slideshowImg_1jf5j_233 img {
height: 100%;
}

._zoomInCursor_1jf5j_3093 {
  cursor: zoom-in;
}

._zoomOutCursor_1jf5j_3101 {
  cursor: zoom-out;
}

._lightboxjsBtn_1jf5j_3109:focus {
  outline: 2px solid #00aaff;
  outline-offset: 4px;
}`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"lightboxjs":"_lightboxjs_1jf5j_1","slideshowBtn":"_slideshowBtn_1jf5j_37","closeIcon":"_closeIcon_1jf5j_45","iconsHeader":"_iconsHeader_1jf5j_49","prev1":"_prev1_1jf5j_53","next1":"_next1_1jf5j_55","icon":"_icon_1jf5j_49","prevIcon":"_prevIcon_1jf5j_69","nextIcon":"_nextIcon_1jf5j_71","show":"_show_1jf5j_81","displayHidden":"_displayHidden_1jf5j_89","thumbnail":"_thumbnail_1jf5j_97","thumbnails":"_thumbnails_1jf5j_133","thumbnailsWithCaption":"_thumbnailsWithCaption_1jf5j_149","thumbnailsOuterContainer":"_thumbnailsOuterContainer_1jf5j_157","navigationDots":"_navigationDots_1jf5j_181","imageSlide":"_imageSlide_1jf5j_197","thumbnailsAndCaption":"_thumbnailsAndCaption_1jf5j_221","hideControlsBar":"_hideControlsBar_1jf5j_233","slideshowImg":"_slideshowImg_1jf5j_233","rotateImgInnerContainer":"_rotateImgInnerContainer_1jf5j_241","slideshowInnerContainer":"_slideshowInnerContainer_1jf5j_249","videoThumbnailsOuterContainer":"_videoThumbnailsOuterContainer_1jf5j_269","imgTitleContainer":"_imgTitleContainer_1jf5j_277","thumbnailsOuterContainerMetadata":"_thumbnailsOuterContainerMetadata_1jf5j_337","htmlVideoOuterContainer":"_htmlVideoOuterContainer_1jf5j_361","caption":"_caption_1jf5j_373","galleryImg":"_galleryImg_1jf5j_393","modalContainer":"_modalContainer_1jf5j_403","slideshowAnimContainer":"_slideshowAnimContainer_1jf5j_441","fullScreenContainer":"_fullScreenContainer_1jf5j_477","imageInnerContainer":"_imageInnerContainer_1jf5j_489","magnifyWrapper":"_magnifyWrapper_1jf5j_527","slideshowInnerVideoContainer":"_slideshowInnerVideoContainer_1jf5j_567","slideshowInnerContainerThumbnails":"_slideshowInnerContainerThumbnails_1jf5j_575","lightboxContainer":"_lightboxContainer_1jf5j_599","slideshowAnimImg":"_slideshowAnimImg_1jf5j_671","controls":"_controls_1jf5j_681","iconHeaderDefault":"_iconHeaderDefault_1jf5j_715","ytVideo":"_ytVideo_1jf5j_727","videoOuterContainer":"_videoOuterContainer_1jf5j_739","customVideoContainer":"_customVideoContainer_1jf5j_767","customEmbedContainer":"_customEmbedContainer_1jf5j_767","videoIconsHeader":"_videoIconsHeader_1jf5j_777","lightbox":"_lightbox_1jf5j_1","imgTitle":"_imgTitle_1jf5j_277","iconHeaderCenter":"_iconHeaderCenter_1jf5j_911","innerContainerWithTopCaption":"_innerContainerWithTopCaption_1jf5j_1103","slideshowImgFullscreen":"_slideshowImgFullscreen_1jf5j_1111","slideshowInnerContainerFullScreen":"_slideshowInnerContainerFullScreen_1jf5j_1163","fullScreenLightboxImg":"_fullScreenLightboxImg_1jf5j_1171","slideshowInnerContainerImgMetadata":"_slideshowInnerContainerImgMetadata_1jf5j_1183","opacityFade":"_opacity-fade_1jf5j_1237","imageSliderThumbnails":"_imageSliderThumbnails_1jf5j_1273","slideshowImgMetadata":"_slideshowImgMetadata_1jf5j_1349","prev1Metadata":"_prev1Metadata_1jf5j_1357","slideshowImgWithCaption":"_slideshowImgWithCaption_1jf5j_1399","hideControlsBarAndCaption":"_hideControlsBarAndCaption_1jf5j_1407","lightboxImg":"_lightboxImg_1jf5j_1425","lightIcon":"_lightIcon_1jf5j_1475","darkIcon":"_darkIcon_1jf5j_1501","lightHeaderIcon":"_lightHeaderIcon_1jf5j_1531","darkHeaderIcon":"_darkHeaderIcon_1jf5j_1557","magnifierImage":"_magnifierImage_1jf5j_1581","active":"_active_1jf5j_1589","inactiveThumbnailBorder":"_inactiveThumbnailBorder_1jf5j_1597","emblaThumbs":"_emblaThumbs_1jf5j_1613","fullScreenSlideshowImg":"_fullScreenSlideshowImg_1jf5j_1659","htmlVideo":"_htmlVideo_1jf5j_361","containImg":"_containImg_1jf5j_1969","reactTransformComponent":"_reactTransformComponent_1jf5j_2001","loader":"_loader_1jf5j_2023","rotation":"_rotation_1jf5j_1","dayLoader":"_dayLoader_1jf5j_2069","nightLoader":"_nightLoader_1jf5j_2079","closeButton":"_closeButton_1jf5j_2101","closeButtonRounded":"_closeButtonRounded_1jf5j_2101","slideImageAndCaption":"_slideImageAndCaption_1jf5j_2193","roundedBorder":"_roundedBorder_1jf5j_2225","maxWidthFull":"_maxWidthFull_1jf5j_2233","maxWidthWithoutMagnifier":"_maxWidthWithoutMagnifier_1jf5j_2241","lightboxVideo":"_lightboxVideo_1jf5j_2379","navigationWrapper":"_navigation-wrapper_1jf5j_2389","dots":"_dots_1jf5j_2397","dot":"_dot_1jf5j_2397","arrow":"_arrow_1jf5j_2447","leftArrow":"_leftArrow_1jf5j_2477","rightArrow":"_rightArrow_1jf5j_2491","arrowDisabled":"_arrow--disabled_1jf5j_2515","navDotsMargin":"_navDotsMargin_1jf5j_2525","inactiveThumbnailBorderImgSlider":"_inactiveThumbnailBorderImgSlider_1jf5j_2533","ytVideoImgSlider":"_ytVideoImgSlider_1jf5j_2541","outerYtVideoImgSlider":"_outerYTVideoImgSlider_1jf5j_2561","imgSliderArrow":"_imgSliderArrow_1jf5j_2581","cursorPointer":"_cursorPointer_1jf5j_2603","lightboxjsIcon":"_lightboxjsIcon_1jf5j_2611","embla":"_embla_1jf5j_1613","emblaViewport":"_emblaViewport_1jf5j_2631","emblaContainer":"_emblaContainer_1jf5j_2641","emblaContainerImgMetadata":"_emblaContainerImgMetadata_1jf5j_2671","imgdrag":"_imgdrag_1jf5j_2683","emblaSlide":"_emblaSlide_1jf5j_2683","emblaThumbsViewport":"_emblaThumbsViewport_1jf5j_2703","emblaThumbsContainer":"_emblaThumbsContainer_1jf5j_2711","emblaThumbsSlide":"_emblaThumbsSlide_1jf5j_2747","emblaThumbsSlideImg":"_emblaThumbsSlideImg_1jf5j_2761","mlAuto":"_mlAuto_1jf5j_2775","metadata":"_metadata_1jf5j_2783","emblaSlideGrid":"_emblaSlideGrid_1jf5j_2791","metadataPanel":"_metadataPanel_1jf5j_2813","metadataInnerContainer":"_metadataInnerContainer_1jf5j_2825","imgMetadataCloseBtn":"_imgMetadataCloseBtn_1jf5j_2843","reactTransformWrapper":"_reactTransformWrapper_1jf5j_2865","navigationDot":"_navigationDot_1jf5j_181","navigationDotContainer":"_navigationDotContainer_1jf5j_2949","imgfade":"_imgfade_1jf5j_2963","notFullScreen":"_notFullScreen_1jf5j_2975","imgFadeWithTopCaption":"_imgFadeWithTopCaption_1jf5j_3011","emblaSlideSelected":"_emblaSlideSelected_1jf5j_3021","fullImg":"_fullImg_1jf5j_3047","rotateImg90Deg":"_rotateImg90Deg_1jf5j_3059","rotateImg":"_rotate_img_1jf5j_3069","zoomInCursor":"_zoomInCursor_1jf5j_3093","zoomOutCursor":"_zoomOutCursor_1jf5j_3101","lightboxjsBtn":"_lightboxjsBtn_1jf5j_3109"};
export { css, digest };
  